// English + Hindi translations. Add a key here, then reference it via t("key") in components.
// Keep keys SHORT and STABLE — do not change once shipped.

export const TRANSLATIONS = {
    en: {
        // Navbar
        "nav.home": "Home",
        "nav.about": "About",
        "nav.services": "Services",
        "nav.courses": "Courses",
        "nav.book": "Book",
        "nav.blog": "Blog",
        "nav.faq": "FAQ",
        "nav.contact": "Contact",
        "nav.book_consultation": "Book Consultation",

        // Hero (Home)
        "hero.eyebrow": "VedicByTannu · Est. 2017",
        "hero.title_a": "Transform Your Life Through",
        "hero.title_b": "Ancient Vedic Wisdom",
        "hero.tagline": "Ancient Vedic Wisdom · Modern Life Solutions",
        "hero.subhead":
            "Personalized astrology consultations with Dr. Tannu Aggarwal — VEDIC and BNN expert with 9+ years guiding careers, relationships, business, foreign settlement, health, and spiritual growth.",
        "hero.cta_book": "Book Consultation",
        "hero.cta_whatsapp": "WhatsApp Now",
        "stats.years": "Years Practicing",
        "stats.lives": "Lives Touched",
        "stats.countries": "Countries Served",
        "stats.rating": "Client Rating",

        // About teaser
        "about.eyebrow": "About Dr. Tannu",
        "about.title": "A modern guide rooted in the ancient science of Jyotish.",
        "about.body":
            "With over 9 years of dedicated study and practice, Dr. Tannu Aggarwal is a recognized expert in Bhrigu Nandi Nadi — one of the most precise predictive systems in Vedic astrology. Her readings have helped seekers across 25+ countries find clarity in career shifts, marriage decisions, business launches, and life's deepest questions.",
        "about.read_more": "Read full story",
        "about.book_now": "Book Now",
        "about.exp.bnn": "Bhrigu Nandi Nadi (BNN) Expert",
        "about.exp.numerology": "Numerology — Chaldean",
        "about.exp.career": "Career & Business Guidance",
        "about.exp.marriage": "Relationship & Marriage Match",
        "about.exp.foreign": "Foreign Settlement Predictions",
        "about.exp.health": "Health & Wellness Astrology",
        "about.exp.horoscope": "Annual Horoscope & Transits",
        "about.exp.remedies": "Vedic Remedies & Muhurat",

        // Services preview
        "services.eyebrow": "Consultations",
        "services.title": "Twelve precise paths to clarity & alignment.",
        "services.view_all": "View All 12 Services",
        "services.book_now": "Book Now",

        // Why us
        "why.eyebrow": "Why VedicByTannu",
        "why.title": "Authentic Jyotish, modern delivery.",

        // Testimonials
        "test.eyebrow": "What Clients Say",
        "test.title": "12,000+ lives. One trusted voice.",

        // Blog preview
        "blog.eyebrow": "Wisdom Journal",
        "blog.title": "Latest from the blog",
        "blog.read_all": "Read all articles",

        // CTA
        "cta.eyebrow": "Begin Your Journey",
        "cta.title": "Your stars have been waiting. Will you listen?",
        "cta.body":
            "A single 45-minute reading can shift the trajectory of a decade. Book now — limited slots each week.",

        // Footer
        "footer.tagline":
            "Ancient Vedic wisdom for modern lives. Authentic consultations rooted in 9+ years of practice in Bhrigu Nandi Nadi.",
        "footer.explore": "Explore",
        "footer.reach": "Reach Out",
        "footer.newsletter": "Newsletter",
        "footer.newsletter_blurb": "Monthly horoscope, transits & remedies. No spam.",
        "footer.email_placeholder": "your@email.com",
        "footer.subscribe": "Subscribe",
        "footer.subscribing": "Subscribing...",
        "footer.copyright": "All rights reserved.",
        "footer.privacy": "Privacy",
        "footer.terms": "Terms",
        "footer.admin": "Admin",
        "footer.about_link": "About Dr. Tannu",
        "footer.services_link": "All Services",
        "footer.courses_link": "Courses",
        "footer.book_link": "My Book — Karakatva",
        "footer.booking_link": "Book Consultation",
        "footer.blog_link": "Blog",
        "footer.faq_link": "FAQ",
        "footer.online_worldwide": "Online — Worldwide",

        // Language toggle
        "lang.label": "Language",
        "lang.en": "English",
        "lang.hi": "हिन्दी",
    },

    hi: {
        // Navbar
        "nav.home": "होम",
        "nav.about": "परिचय",
        "nav.services": "सेवाएँ",
        "nav.courses": "कोर्सेस",
        "nav.book": "किताब",
        "nav.blog": "ब्लॉग",
        "nav.faq": "प्रश्न",
        "nav.contact": "संपर्क",
        "nav.book_consultation": "परामर्श बुक करें",

        // Hero (Home)
        "hero.eyebrow": "वेदिकबायटन्नू · स्थापित 2017",
        "hero.title_a": "अपना जीवन रूपांतरित करें",
        "hero.title_b": "प्राचीन वैदिक ज्ञान से",
        "hero.tagline": "प्राचीन वैदिक ज्ञान · आधुनिक जीवन समाधान",
        "hero.subhead":
            "डॉ. तन्नू अग्रवाल के साथ व्यक्तिगत ज्योतिष परामर्श — 9+ वर्षों से करियर, रिश्ते, व्यवसाय, विदेश यात्रा, स्वास्थ्य और आध्यात्मिक विकास में मार्गदर्शन देने वाली वैदिक एवं BNN विशेषज्ञ।",
        "hero.cta_book": "परामर्श बुक करें",
        "hero.cta_whatsapp": "व्हाट्सएप करें",
        "stats.years": "वर्षों का अनुभव",
        "stats.lives": "जीवन स्पर्श",
        "stats.countries": "देशों में सेवा",
        "stats.rating": "क्लाइंट रेटिंग",

        // About teaser
        "about.eyebrow": "डॉ. तन्नू के बारे में",
        "about.title": "ज्योतिष के प्राचीन विज्ञान में रची-बसी एक आधुनिक मार्गदर्शिका।",
        "about.body":
            "9+ वर्षों के समर्पित अध्ययन और अभ्यास के साथ, डॉ. तन्नू अग्रवाल भृगु नंदी नाड़ी की मान्यता-प्राप्त विशेषज्ञ हैं — वैदिक ज्योतिष की सबसे सटीक भविष्यवाणी प्रणालियों में से एक। उनकी रीडिंग्स ने 25+ देशों के साधकों को करियर, विवाह, व्यापार और जीवन के गहरे प्रश्नों में स्पष्टता दी है।",
        "about.read_more": "पूरी कहानी पढ़ें",
        "about.book_now": "अभी बुक करें",
        "about.exp.bnn": "भृगु नंदी नाड़ी (BNN) विशेषज्ञ",
        "about.exp.numerology": "अंक ज्योतिष — कैल्डियन",
        "about.exp.career": "करियर एवं व्यवसाय मार्गदर्शन",
        "about.exp.marriage": "रिश्ते एवं विवाह मिलान",
        "about.exp.foreign": "विदेश यात्रा भविष्यवाणी",
        "about.exp.health": "स्वास्थ्य ज्योतिष",
        "about.exp.horoscope": "वार्षिक राशिफल एवं गोचर",
        "about.exp.remedies": "वैदिक उपाय एवं मुहूर्त",

        // Services preview
        "services.eyebrow": "परामर्श",
        "services.title": "स्पष्टता और संरेखण के बारह सटीक मार्ग।",
        "services.view_all": "सभी 12 सेवाएँ देखें",
        "services.book_now": "बुक करें",

        // Why us
        "why.eyebrow": "क्यों वेदिकबायटन्नू",
        "why.title": "प्रामाणिक ज्योतिष, आधुनिक प्रस्तुति।",

        // Testimonials
        "test.eyebrow": "ग्राहक क्या कहते हैं",
        "test.title": "12,000+ जीवन। एक विश्वसनीय आवाज़।",

        // Blog preview
        "blog.eyebrow": "ज्ञान पत्रिका",
        "blog.title": "ब्लॉग से नवीनतम",
        "blog.read_all": "सभी लेख पढ़ें",

        // CTA
        "cta.eyebrow": "अपनी यात्रा शुरू करें",
        "cta.title": "आपके सितारे प्रतीक्षा कर रहे हैं। क्या आप सुनेंगे?",
        "cta.body":
            "एक 45-मिनट की रीडिंग एक दशक की दिशा बदल सकती है। अभी बुक करें — हर सप्ताह सीमित स्लॉट।",

        // Footer
        "footer.tagline":
            "आधुनिक जीवन के लिए प्राचीन वैदिक ज्ञान। भृगु नंदी नाड़ी में 9+ वर्षों के अभ्यास पर आधारित प्रामाणिक परामर्श।",
        "footer.explore": "जानें",
        "footer.reach": "संपर्क करें",
        "footer.newsletter": "न्यूज़लेटर",
        "footer.newsletter_blurb": "मासिक राशिफल, गोचर एवं उपाय। कोई स्पैम नहीं।",
        "footer.email_placeholder": "आपका@ईमेल.com",
        "footer.subscribe": "सब्सक्राइब",
        "footer.subscribing": "हो रहा है...",
        "footer.copyright": "सर्वाधिकार सुरक्षित।",
        "footer.privacy": "गोपनीयता",
        "footer.terms": "शर्तें",
        "footer.admin": "एडमिन",
        "footer.about_link": "डॉ. तन्नू के बारे में",
        "footer.services_link": "सभी सेवाएँ",
        "footer.courses_link": "कोर्सेस",
        "footer.book_link": "हमारी किताब — कारकत्व",
        "footer.booking_link": "परामर्श बुक करें",
        "footer.blog_link": "ब्लॉग",
        "footer.faq_link": "प्रश्नोत्तर",
        "footer.online_worldwide": "ऑनलाइन — विश्व भर में",

        // Language toggle
        "lang.label": "भाषा",
        "lang.en": "English",
        "lang.hi": "हिन्दी",
    },
};
